import React from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import PhoneUsageDemo from "../../components/PhoneUsageDemo";
import { ACCENT_DARK } from "../../theme/brand";

const POINTS = [
  { icon: "mdi:account-group", text: "Mitgliederliste mit Gürtelgrad auf einen Blick" },
  { icon: "mdi:bank-transfer", text: "Abbuchungsstatus direkt im Mitgliedsprofil" },
  { icon: "mdi:cellphone-check", text: "Funktioniert im Browser – kein Download nötig" },
];

export default function MobileShowcase() {
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "grey.50" }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 2 }}>
              Unterwegs
            </Typography>
            <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em" sx={{ mt: 1, mb: 2 }}>
              Auch vom Handy aus im Griff
            </Typography>
            <Typography sx={{ color: "grey.600", fontSize: 17, mb: 3.5, maxWidth: 480 }}>
              Zwischen zwei Trainings kurz nachsehen, wer fällig ist, oder den
              Gürtelgrad eines Mitglieds prüfen – MartialVerse läuft im
              Browser deines Smartphones, ganz ohne eigene App.
            </Typography>
            <Stack spacing={1.75}>
              {POINTS.map((point) => (
                <Stack key={point.text} direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      bgcolor: "rgba(91,79,212,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Iconify icon={point.icon} width={16} sx={{ color: ACCENT_DARK }} />
                  </Box>
                  <Typography sx={{ color: "grey.700", fontWeight: 600, fontSize: 14.5 }}>
                    {point.text}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            <Reveal delay={100} sx={{ display: "flex", justifyContent: "center" }}>
              <PhoneUsageDemo />
            </Reveal>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
